"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViacomAccountService = exports.viacomAccountService = void 0;
var auth_suite_fetch_1 = require("../../auth-suite-fetch");
var models_1 = require("../../auth-suite-sdk-setup/models");
var expired_token_error_handling_strategy_1 = require("../../error-handlers/expired-token-error-handling-strategy");
var models_2 = require("../../models");
var access_1 = require("../access");
var models_3 = require("../user-id/models");
var get_viacom_account_details_guard_1 = require("./response-guards/get-viacom-account-details-guard");
var requestRoute = "viacomAccount";
var resendVerificationEmailRoute = "".concat(requestRoute, "/verify/resend");
var getDevicesList = function () {
    var getDevicesListRoute = "".concat(requestRoute, "/devices");
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.get({
        path: getDevicesListRoute,
    });
};
var signIn = function (request) {
    var signInRequestRoute = "".concat(requestRoute, "/signIn");
    var payload = {
        email: request.email,
        password: request.password,
    };
    var body = JSON.stringify(payload);
    var requestParams = [models_2.AuthSuiteRequestParams.ActivationCode];
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization
        .post({
        body: body,
        path: signInRequestRoute,
        request: request,
        requestParams: requestParams,
    })
        .then(function (signInResponse) { return refreshTokenAfterSignIn(signInResponse); });
};
var signInIdentified = function () {
    var signInIdentifiedRequestRoute = "".concat(requestRoute, "/signInIdentified");
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization
        .post({
        path: signInIdentifiedRequestRoute,
    })
        .then(function (signInIdentifiedResponse) {
        return refreshTokenAfterSignInIdentified(signInIdentifiedResponse);
    });
};
var signUp = function (request) {
    var signUpRequestRoute = "".concat(requestRoute, "/signUp");
    var payload = {
        email: request.email,
        password: request.password,
        profile: request.profile,
        marketingOptIn: request.marketingOptIn,
    };
    var body = JSON.stringify(payload);
    var requestParams = [models_2.AuthSuiteRequestParams.ActivationCode, models_2.AuthSuiteRequestParams.PromoCode];
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.post({
        body: body,
        path: signUpRequestRoute,
        request: request,
        requestParams: requestParams,
    });
};
var verify = function (request) {
    var verifyRoute = "".concat(requestRoute, "/verify");
    var payload = {
        verificationToken: request.verificationToken,
    };
    var body = JSON.stringify(payload);
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.patch({
        body: body,
        path: verifyRoute,
        request: request,
    });
};
var resendVerificationEmailToSignedInUser = function () {
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.post({
        path: resendVerificationEmailRoute,
    });
};
var resendVerificationEmail = function (request) {
    var payload = {
        email: request.email,
    };
    var body = JSON.stringify(payload);
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.post({
        body: body,
        path: resendVerificationEmailRoute,
    });
};
var signUpAndSignIn = function (request) {
    var signUpAndSignInRequestRoute = "".concat(requestRoute, "/signUpAndSignIn");
    var payload = {
        email: request.email,
        password: request.password,
        profile: request.profile,
        marketingOptIn: request.marketingOptIn,
    };
    var body = JSON.stringify(payload);
    var requestParams = [models_2.AuthSuiteRequestParams.ActivationCode, models_2.AuthSuiteRequestParams.PromoCode];
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.post({
        body: body,
        path: signUpAndSignInRequestRoute,
        request: request,
        requestParams: requestParams,
    });
};
var isUserLoggedInWithViacomAccount = function () {
    return access_1.accessService
        .checkAccessStatus()
        .then(function (response) { return hasViacomAccountAccessMethod(response.accessMethodsInUse); });
};
var getViacomAccountDetails = function () {
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization
        .get({
        path: requestRoute,
        responseGuard: (0, get_viacom_account_details_guard_1.getViacomAccountDetailsGuard)(requestRoute),
    })
        .then(function (response) { return response; });
};
var hasViacomAccountAccessMethod = function (contentAccessMethods) {
    var viacomAccountAccessMethod = contentAccessMethods.find(function (method) {
        return method.type === models_1.ContentAccessMethodType.Social && method.providerCode === models_3.AccessMethodId.APE;
    });
    return Boolean(viacomAccountAccessMethod);
};
var refreshTokenAfterSignIn = function (signInResponse) {
    return expired_token_error_handling_strategy_1.expiredTokenErrorHandlingContext.handleTokenRefresh().then(function () {
        return signInResponse;
    });
};
var refreshTokenAfterSignInIdentified = function (signInIdentifiedResponse) {
    return expired_token_error_handling_strategy_1.expiredTokenErrorHandlingContext.handleTokenRefresh().then(function () {
        return signInIdentifiedResponse;
    });
};
var signOutDevices = function (request) {
    var getLogoutDevicesRoute = "".concat(requestRoute, "/devices/signOut");
    var body = JSON.stringify(request);
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.post({
        body: body,
        path: getLogoutDevicesRoute,
    });
};
exports.viacomAccountService = {
    getDevicesList: getDevicesList,
    getViacomAccountDetails: getViacomAccountDetails,
    isUserLoggedInWithViacomAccount: isUserLoggedInWithViacomAccount,
    resendVerificationEmail: resendVerificationEmail,
    resendVerificationEmailToSignedInUser: resendVerificationEmailToSignedInUser,
    signIn: signIn,
    signInIdentified: signInIdentified,
    signOutDevices: signOutDevices,
    signUp: signUp,
    signUpAndSignIn: signUpAndSignIn,
    verify: verify,
};
var ViacomAccountService = /** @class */ (function () {
    function ViacomAccountService() {
        return exports.viacomAccountService;
    }
    return ViacomAccountService;
}());
exports.ViacomAccountService = ViacomAccountService;
